export function handleServiceWorkerOnUpdate(registration) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    setTimeout(() => {
        window.location.reload();
    }, 1000)
}